// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3cuUP","label":"Section_label__3vkMz","contentWrap":"Section_contentWrap__2ETes","footer":"Section_footer__3w4RE","footerInner":"Section_footerInner__Jo2_Y"};